import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { defineStyles, theme } from '../theme';
import { useSTRowFilterCondition } from '../table';
import { MaxRecordsCustomCountSchema } from './schema';
const styles = defineStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    input: {
        maxWidth: 100,
        '& .MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-input': {
                p: 0,
            },
            '& fieldset, &:hover fieldset, &.Mui-focused fieldset': {
                border: 0,
                borderBottom: `1px solid ${theme.vars.palette.border.main}`,
                borderRadius: 0,
            },
            '& fieldset': {
                borderBottom: `1px solid ${theme.vars.palette.border.light}`,
            },
        },
    },
    button: {
        p: 0,
    },
});
const MaxRecordsCustomCountForm = ({ onResetClick }) => {
    const [condition, setCondition] = useSTRowFilterCondition();
    const [showReset, setShowReset] = useState(false);
    const form = useForm({
        defaultValues: { maxRecords: condition?.maxRecords ?? undefined },
        resolver: zodResolver(MaxRecordsCustomCountSchema),
    });
    const { control, handleSubmit } = form;
    const inputRef = useRef(null);
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);
    const onSubmit = (data, e) => {
        e?.preventDefault();
        setCondition((prev) => ({ ...(prev ?? { andConditions: [] }), maxRecords: data.maxRecords }));
        setShowReset(true);
    };
    const onReset = () => {
        onResetClick();
        setShowReset(false);
    };
    return (_jsxs(Box, { sx: styles.root, component: "form", onSubmit: handleSubmit(onSubmit, console.error), children: [_jsx(Controller, { name: "maxRecords", control: control, render: ({ field, fieldState: { error } }) => (_jsx(TextField, { ...field, sx: styles.input, size: "small", type: "number", error: !!error, inputRef: inputRef, inputMode: "numeric", inputProps: { min: 0 } })) }), _jsx(Button, { type: "submit", size: "small", sx: styles.button, children: _jsx(FormattedMessage, { id: "common.apply.button", defaultMessage: "Apply" }) }), showReset && (_jsx(Button, { color: "error", onClick: onReset, size: "small", sx: styles.button, children: _jsx(FormattedMessage, { id: "common.reset.button", defaultMessage: "Reset" }) }))] }));
};
export default MaxRecordsCustomCountForm;
//# sourceMappingURL=MaxRecordsCustomCountForm.js.map